import InsertIcon from "@/assets/images/insert-picture@2x.png";
import LikeIcon from "@/assets/images/like@2x.png";
import PolygonIcon from "@/assets/images/Polygon@2x.png";
import {
  fetchTownImagesAsync,
  setCurrentModal,
  toggleModal,
} from "@/store/slices/GlobalSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

const ToolTipPortion = () => {
  const dispatch = useDispatch();
  const { tooltipData } = useSelector((state) => state.globalSlice);

  const handleViewPicture = () => {
    dispatch(fetchTownImagesAsync(tooltipData.term_id));
    dispatch(toggleModal());
    dispatch(setCurrentModal("townSlider"));
  };

  return (
    <div
      id="tooltip-portion"
      className="hidden md:block tooltip-portion md:pointer-events-none opacity-0 absolute bg-sgbc-green-800 py-2 px-4 rounded-xl text-center min-w-165 max-w-165 z-50 transition-all duration-200 ease-in-out"
    >
      <span className="text-sm text-sgbc-yellow-200 font-semibold mb-1 inline-block">
        {tooltipData?.name || ""}
      </span>

      <div className="text-white text-23 font-medium flex justify-between mb-2">
        <figure className="inline-flex items-center space-x-1">
          <span>{tooltipData?.total_voted}</span>

          <span>
            <img style={{ width: "20px" }} src={LikeIcon} alt="icon" />
          </span>
        </figure>

        <figure className="inline-flex items-center space-x-1">
          <span>{tooltipData?.total_images}</span>
          <span>
            <img style={{ width: "20px" }} src={InsertIcon} alt="icon" />
          </span>
        </figure>
      </div>

      <figure>
        <span
          className="text-white text-sm font-semibold underline cursor-pointer"
          onClick={handleViewPicture}
        >
          View Entries {">"}
        </span>
      </figure>

      <figure
        className="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{ bottom: "-50px" }}
      >
        <img src={PolygonIcon} alt="icon" />
      </figure>
    </div>
  );
};

ToolTipPortion.propTypes = {};

export default ToolTipPortion;
